export default "__VITE_ASSET__CJR1tvSt__"